
import React, { useState, useEffect } from 'react';

const GuardianAngel: React.FC = () => {
  const [active, setActive] = useState(false);
  const [statusMessage, setStatusMessage] = useState("SYSTEM STANDBY");

  useEffect(() => {
    let interval: any;
    if (active) {
      setStatusMessage("SENTINEL ACTIVE - SCANNING");
      // Simulate scanning log
      interval = setInterval(() => {
         const msgs = ["SCANNING USGS...", "CHECKING FIRMS DATA...", "MONITORING BAROMETRIC PRESSURE...", "NO THREATS DETECTED", "CALIBRATING SENSORS...", "PINGING LOCAL TOWERS..."];
         const randomMsg = msgs[Math.floor(Math.random() * msgs.length)];
         setStatusMessage(randomMsg);
      }, 2500);
    } else {
      setStatusMessage("SYSTEM STANDBY");
    }
    return () => clearInterval(interval);
  }, [active]);

  return (
    <div className={`h-full w-full flex flex-col items-center justify-center transition-colors duration-1000 relative overflow-hidden pt-28 pb-20 ${active ? 'bg-black' : 'bg-void'}`}>
      
      {/* Background Ambience */}
      {active && (
         <div className="absolute inset-0 bg-red-900/5 animate-pulse"></div>
      )}

      {/* Sentinel Eye / Radar */}
      <div className="relative mb-16 z-10">
        {active && (
          <>
            <div className="absolute inset-[-40px] border border-neon-cyan/20 rounded-full animate-[spin_8s_linear_infinite]"></div>
            <div className="absolute inset-[-30px] border border-neon-cyan/30 rounded-full animate-[spin_4s_linear_infinite_reverse] border-t-transparent border-b-transparent"></div>
            <div className="absolute inset-0 border-2 border-neon-cyan/30 rounded-full animate-ping"></div>
          </>
        )}
        
        {/* Central Core */}
        <div className={`w-56 h-56 rounded-full border-2 flex items-center justify-center backdrop-blur-md transition-all duration-700 relative overflow-hidden ${
            active 
            ? 'border-neon-cyan bg-black/40 shadow-[0_0_60px_rgba(0,240,255,0.3)]' 
            : 'border-white/10 bg-white/5'
        }`}>
           {/* Inner Scanner */}
           {active && (
              <div className="absolute w-full h-1 bg-neon-cyan/50 blur-sm animate-[scan_2s_linear_infinite]"></div>
           )}
           
           <div className="text-center z-10">
             <div className={`text-5xl font-bold tracking-tighter transition-all duration-300 ${active ? 'text-neon-cyan drop-shadow-[0_0_10px_rgba(0,240,255,0.8)]' : 'text-gray-700'}`}>
               {active ? 'ON' : 'OFF'}
             </div>
             <div className="text-[10px] font-mono mt-2 tracking-[0.3em] text-gray-500">
               {active ? 'PROTECTED' : 'DISABLED'}
             </div>
           </div>
        </div>
      </div>

      <div className="z-10 text-center">
        <h2 className={`text-3xl font-bold tracking-[0.2em] mb-4 transition-colors ${active ? 'text-white' : 'text-gray-600'}`}>
          GUARDIAN ANGEL
        </h2>
        <div className="h-6 mb-12">
            <p className="text-xs font-mono text-neon-cyan tracking-widest animate-pulse">
                {active ? `> ${statusMessage}` : statusMessage}
            </p>
        </div>

        {/* Activation Switch */}
        <button
            onClick={() => setActive(!active)}
            className={`group relative px-10 py-5 rounded-xl font-bold text-sm tracking-[0.2em] border transition-all duration-300 overflow-hidden ${
            active 
                ? 'bg-red-500/10 border-red-500 text-red-500 hover:bg-red-500 hover:text-white shadow-[0_0_30px_rgba(255,0,0,0.3)]' 
                : 'bg-neon-cyan/5 border-neon-cyan text-neon-cyan hover:bg-neon-cyan hover:text-black shadow-[0_0_20px_rgba(0,240,255,0.1)]'
            }`}
        >
            <span className="relative z-10">{active ? 'DEACTIVATE PROTOCOL' : 'INITIALIZE PROTOCOL'}</span>
        </button>

        {active && (
            <p className="mt-8 text-[10px] text-gray-500 max-w-xs mx-auto text-center font-mono leading-relaxed border-t border-white/10 pt-4">
            SYSTEM MONITORING SEISMIC & ATMOSPHERIC DATA.<br/>
            AUTO-WAKE ENABLED FOR ALERTS &gt; GRADE 4.
            </p>
        )}
      </div>
    </div>
  );
};

export default GuardianAngel;
